<template>
  <div style="height: 100%;">
    <div class="kt-grid kt-grid--hor kt-grid--root">
      <HeaderMobile />
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
        <Sidebar />
        <div :style="isCreatingOrder ? 'padding-left: 0;': ''" class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
          <Header />
          <div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
            <div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid mx-auto" style="max-width: 1600px">
              <slot />
            </div>
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>
    <ScrollTop />
  </div>
</template>

<script>
import HeaderMobile from '@/components/HeaderMobile.vue';
import Sidebar from '@/components/Sidebar.vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ScrollTop from '@/components/Scrolltop.vue';
import isCreatingOrder from "@/mixins/isCreatingOrder.js";

export default {
  name: 'BaseLayout',
  components: {
    HeaderMobile,
    Sidebar,
    Header,
    Footer,
    ScrollTop: ScrollTop,
  },
  mixins: [isCreatingOrder],
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .kt-content {
    margin-top: 20px !important;
    padding-bottom: 0 !important;
  }
}
</style>
